<!-- The bar measures its direct parent, so that parent is the panel itself, whose width
     comes from the surrounding row rather than from the bar's own content. -->
<div class="background-1 d-flex align-items-center gap-4 pe-auto">
  <si-content-action-bar
    viewType="expanded"
    [primaryActions]="primaryActions()"
    [secondaryActions]="secondaryActions()"
  />

  @if (!readonlyMode()) {
    <button
      type="button"
      class="btn btn-primary text-nowrap"
      [disabled]="!canExport()"
      (click)="exportToUi.emit()"
    >
      <i class="icon element-export"></i>
      {{ 'BROUTER_MAP.EXPORT_TO_UI' | translate }}
    </button>
  }
</div>
